import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Post from "@/pages/post/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/en" replace />,
  },
  {
    path: "/:lang",
    element: <Home />,
  },
  {
    path: "/:lang/spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/:lang/:slug",
    element: <Post />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;